import { $http, buildHeaders } from "./index";

//申诉管理
export const ptsmessage_list = (params) => {
  return $http.get("/admin/PtsMessage/getZyssfxtx", { params });
};

//获取申诉详情
export const ptsmessage_detail = (id) => {
  return $http.get("/admin/PtsMessage/getZyssfxtxDetail?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//处理申诉信息
export const ptsmessage_check = (data) => {
  return $http.post("/admin/PtsMessage/dealZyssfxtx", data, {
    headers: buildHeaders(3),
  });
};

//从税局更新数据
export const ptsmessage_pull = (data) => {
  return $http.post("/admin/PtsMessage/pull", data, {
    headers: buildHeaders(3),
  });
};
